export * from './tab-nav-bar';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/@angular/material/tabs/tab-nav-bar/index.js
// module id = ../../../material/tabs/tab-nav-bar/index.js
// module chunks = 3